import { render, staticRenderFns } from "./tab-bar-slider.mpx?vue&type=template&id=3b6d4a16&isComponent&outputPath=components%2Ftab-bar-slider6220f06a%2Findex"
import script from "./tab-bar-slider.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Ftab-bar-slider6220f06a%2Findex"
export * from "./tab-bar-slider.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Ftab-bar-slider6220f06a%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports